// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChallengeCompletePage.css - Based on Figma Design */

.challenge-complete-page {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background-color: #3B0065;
  padding: 24px;
  box-sizing: border-box;
  overflow: hidden;
}

.challenge-complete-background {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.challenge-complete-background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.challenge-complete-card {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 616px;
  width: 100%;
  padding: 80px 48px;
  background-color: #FFFFFF;
  border-radius: 24px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.15);
}

.challenge-complete-icon {
  margin-bottom: 24px;
}

.challenge-complete-icon svg {
  width: 111px;
  height: 122px;
}

.challenge-complete-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 800;
  font-style: italic;
  font-size: 32px;
  line-height: 1.2;
  letter-spacing: -0.16px;
  color: #236CFF;
  margin: 0 0 8px 0;
}

.challenge-complete-description {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6;
  color: #21262A;
  margin: 0 0 32px 0;
  max-width: 520px;
}

.challenge-complete-link {
  color: #236CFF;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.challenge-complete-link:hover {
  color: #1a52cc;
}

.challenge-complete-link:focus {
  outline: 2px solid #236CFF;
  outline-offset: 2px;
  border-radius: 2px;
}

.challenge-complete-buttons {
  display: flex;
  gap: 16px;
  align-items: center;
}

.challenge-complete-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 140px;
  padding: 10px 24px;
  border-radius: 9999px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  transition: all 0.2s ease;
}

.challenge-complete-btn-secondary {
  background-color: transparent;
  border: 2px solid #00254B;
  color: #00254B;
}

.challenge-complete-btn-secondary:hover {
  background-color: #00254B;
  color: #FFFFFF;
}

.challenge-complete-btn-secondary:focus {
  outline: 2px solid #00254B;
  outline-offset: 2px;
}

.challenge-complete-btn-primary {
  background-color: #00254B;
  border: 2px solid #00254B;
  color: #FFFFFF;
}

.challenge-complete-btn-primary:hover {
  background-color: #001a36;
  border-color: #001a36;
}

.challenge-complete-btn-primary:focus {
  outline: 2px solid #00254B;
  outline-offset: 2px;
}

/* Responsive */
@media (max-width: 700px) {
  .challenge-complete-card {
    padding: 48px 32px;
    max-width: 100%;
  }

  .challenge-complete-title {
    font-size: 28px;
  }

  .challenge-complete-description {
    font-size: 16px;
  }

  .challenge-complete-buttons {
    flex-direction: column;
    width: 100%;
  }

  .challenge-complete-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .challenge-complete-card {
    padding: 32px 24px;
  }

  .challenge-complete-icon svg {
    width: 80px;
    height: 88px;
  }

  .challenge-complete-title {
    font-size: 24px;
  }

  .challenge-complete-description {
    font-size: 14px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/ChallengeCompletePage.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ChallengeCompletePage.css - Based on Figma Design */\n\n.challenge-complete-page {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 100vh;\n  background-color: #3B0065;\n  padding: 24px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.challenge-complete-background {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.challenge-complete-background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.challenge-complete-card {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 616px;\n  width: 100%;\n  padding: 80px 48px;\n  background-color: #FFFFFF;\n  border-radius: 24px;\n  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.15);\n}\n\n.challenge-complete-icon {\n  margin-bottom: 24px;\n}\n\n.challenge-complete-icon svg {\n  width: 111px;\n  height: 122px;\n}\n\n.challenge-complete-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 800;\n  font-style: italic;\n  font-size: 32px;\n  line-height: 1.2;\n  letter-spacing: -0.16px;\n  color: #236CFF;\n  margin: 0 0 8px 0;\n}\n\n.challenge-complete-description {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #21262A;\n  margin: 0 0 32px 0;\n  max-width: 520px;\n}\n\n.challenge-complete-link {\n  color: #236CFF;\n  text-decoration: underline;\n  transition: color 0.2s ease;\n}\n\n.challenge-complete-link:hover {\n  color: #1a52cc;\n}\n\n.challenge-complete-link:focus {\n  outline: 2px solid #236CFF;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.challenge-complete-buttons {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.challenge-complete-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 140px;\n  padding: 10px 24px;\n  border-radius: 9999px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 28px;\n  transition: all 0.2s ease;\n}\n\n.challenge-complete-btn-secondary {\n  background-color: transparent;\n  border: 2px solid #00254B;\n  color: #00254B;\n}\n\n.challenge-complete-btn-secondary:hover {\n  background-color: #00254B;\n  color: #FFFFFF;\n}\n\n.challenge-complete-btn-secondary:focus {\n  outline: 2px solid #00254B;\n  outline-offset: 2px;\n}\n\n.challenge-complete-btn-primary {\n  background-color: #00254B;\n  border: 2px solid #00254B;\n  color: #FFFFFF;\n}\n\n.challenge-complete-btn-primary:hover {\n  background-color: #001a36;\n  border-color: #001a36;\n}\n\n.challenge-complete-btn-primary:focus {\n  outline: 2px solid #00254B;\n  outline-offset: 2px;\n}\n\n/* Responsive */\n@media (max-width: 700px) {\n  .challenge-complete-card {\n    padding: 48px 32px;\n    max-width: 100%;\n  }\n\n  .challenge-complete-title {\n    font-size: 28px;\n  }\n\n  .challenge-complete-description {\n    font-size: 16px;\n  }\n\n  .challenge-complete-buttons {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .challenge-complete-btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .challenge-complete-card {\n    padding: 32px 24px;\n  }\n\n  .challenge-complete-icon svg {\n    width: 80px;\n    height: 88px;\n  }\n\n  .challenge-complete-title {\n    font-size: 24px;\n  }\n\n  .challenge-complete-description {\n    font-size: 14px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
